import ctiRequest from "../../axios/ctiRequests"
import axios from "../../axios/ctiConfig";
import { notify } from "../../helpers/utility";
import * as actionTypes from "./actionTypes";



export const callAgentHistoryStart = () =>{
    return{
        type: actionTypes.CALL_AGENT_HISTORY_START
    }
}
export const callAgentHistorySuccess = (recentCalls) =>{
    return {
        type: actionTypes.CALL_AGENT_HISTORY_SUCCESS,
        recentCalls: recentCalls,
      };
}
export const callAgentHistoryFail = (error) =>{
     return {
        type: actionTypes.CALL_AGENT_HISTORY_FAIL,
        error: error,
      };
}


export const callAgentHistory = (agentId, dateTime, limit, callDisp, callType) => {
    return (dispatch) => {
        dispatch(callAgentHistoryStart());

        const requestBody = {
            ...ctiRequest["CALL_HISTORY_BY_AGENT"],
            agent_id: agentId,
            datetime: dateTime,
            call_disposition: callDisp,
            call_type: callType
        };

        if (limit > 0) {
            requestBody.limit = limit;
        }

        fetch(window.Configs.ldap_url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        })
        .then((response) => response.json())

        .then((result) => {
            if (
                result.status === "SUCCESS" ||
                (result.status === "FAILURE" &&
                 result.reason === "No Data Availabe.")
            ) {
                dispatch(callAgentHistorySuccess(result.data.recent_calls));
            } else {
                dispatch(callAgentHistoryFail(result.message));
                notify("Call Data Error: " + result.message, "call-data");
            }
        })
        .catch((err) => {
            dispatch(callAgentHistoryFail(err));
        });
    };
};
